import {
  useGetChecklistById,
  useGetChecklistRoles,
} from '@core/react-query/features/checklists/checklist'
import { useGetPermitRecentParticipants } from '@core/react-query/features/permits'
import { useGetChecklistRecentParticipants } from '@core/react-query/features/checklists'
import {
  useGetPermitRoles,
  usePermitById,
} from '@core/react-query/features/permits/permit'

type IdPayload = {
  id: number
}

export const briefingsGenericHooksByEntityType = {
  CHECKLIST: {
    useGetEntityById: (
      payload: IdPayload,
      options?: Parameters<typeof useGetChecklistById>[1],
    ) => useGetChecklistById({ checklistId: payload.id }, options),
    useGetEntityRoles: (
      payload: IdPayload,
      options?: Parameters<typeof useGetChecklistRoles>[1],
    ) => useGetChecklistRoles({ checklistId: payload.id }, options),
    useGetEntityRecentParticipants: useGetChecklistRecentParticipants,
  },
  PERMIT: {
    useGetEntityById: (
      payload: IdPayload,
      options?: Parameters<typeof usePermitById>[1],
    ) => usePermitById({ permitId: payload.id }, options),
    useGetEntityRoles: (
      payload: IdPayload,
      options?: Parameters<typeof useGetPermitRoles>[1],
    ) => useGetPermitRoles({ permitId: payload.id }, options),
    useGetEntityRecentParticipants: useGetPermitRecentParticipants,
  },
}
